import {Flash} from '@primer/react'
import {ChecksSection} from './ChecksSection'
import type {MergeabilityData} from '../use-mergeability-data'

interface PendingChecksBodyProps {
  data: MergeabilityData
  /** Message shown when there are no individual checks to list yet */
  emptyMessage: string
  itemName: string
}

// Shared body for the pending checks For You items - renders the full checks list,
// or an explanatory message when no individual checks have been reported yet
export function PendingChecksBody({data, emptyMessage, itemName}: PendingChecksBodyProps) {
  const {mergeBoxPullRequest, statusChecks, statusRollup} = data

  if (statusChecks.length === 0) {
    return (
      <Flash className="tmp-m-3" variant="default">
        {emptyMessage}
      </Flash>
    )
  }

  return (
    <ChecksSection
      statusChecks={statusChecks}
      mergeBoxPullRequest={mergeBoxPullRequest}
      statusRollup={statusRollup}
      itemName={itemName}
    />
  )
}
